import { render } from "./index.vue?vue&type=template&id=53f11328&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts&config=true"
export * from "./index.vue?vue&type=script&lang=ts&config=true"

import "./index.vue?vue&type=style&index=0&id=53f11328&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f11328"]])

export default __exports__